(() => {
  function init() {
    const swatches = document.querySelectorAll('.linked-products__option[data-variant-map]');
    if (!swatches.length) return;

    const variantRadios = document.querySelector('variant-radios');
    if (!variantRadios) return;

    function updateSwatchHrefs() {
      const selectedInputs = variantRadios.querySelectorAll('input:checked');
      const selectedValues = new Set(Array.from(selectedInputs).map((input) => input.value));

      swatches.forEach((swatch) => {
        let variants;
        try {
          variants = JSON.parse(swatch.dataset.variantMap);
        } catch {
          return;
        }

        const basePath = swatch.getAttribute('href').split('?')[0];

        // Find the variant with the most option-value matches to the current selection.
        let bestId = null;
        let bestScore = -1;
        variants.forEach((variant) => {
          const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
          const score = options.filter((o) => selectedValues.has(o)).length;
          if (score > bestScore) {
            bestScore = score;
            bestId = variant.id;
          }
        });

        swatch.setAttribute('href', bestId ? `${basePath}?variant=${bestId}` : basePath);
      });
    }

    variantRadios.addEventListener('change', updateSwatchHrefs);
    updateSwatchHrefs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
